import { render, staticRenderFns } from "./riskdrawer.vue?vue&type=template&id=655ba42e&scoped=true&"
import script from "./riskdrawer.vue?vue&type=script&lang=js&"
export * from "./riskdrawer.vue?vue&type=script&lang=js&"
import style0 from "./riskdrawer.vue?vue&type=style&index=0&id=655ba42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ba42e",
  null
  
)

export default component.exports